import {requests} from "../../data/People/requests";
// import * as net from "../../utils/network";

export const ACTION_GET_REQUESTS = 'ACTION_GET_REQUESTS';
export const ACTION_ADD_NEW_PEOPLE = 'ACTION_ADD_NEW_PEOPLE';
export const ACTION_CANCEL_REQUESTS_PEOPLE = 'ACTION_CANCEL_REQUESTS_PEOPLE';
// function actionRequestsLoaded(requests) {
//     return {
//         type: ACTION_GET_STUDENTS,
//         payload: requests
//     };
// }
//
// CREATORS
// export function getStudents() {
//     return (dispatch, getState) => {
//         const {core} = getState();
//
//         net.aGet('')
//             .then(data => {
//                 dispatch(actionRequestsLoaded(data.filter((requests) => requests === core.requests))); //or any other relevant condition
//             });
//     };
// }

export function getRequests() {
    return {
        type: ACTION_GET_REQUESTS,
        payload: requests
    };
}

export function addNewPeople(user) {
    return {
        type: ACTION_ADD_NEW_PEOPLE,
        payload: user
    }
}

export function cancelRequestsPeople(id) {
    return {
        type: ACTION_CANCEL_REQUESTS_PEOPLE,
        payload: id
    }
}





// WEBPACK FOOTER //
// ./src/store/actions/addPeopleActions.js